<!-- <div class="flex justify-content-end flex-wrap card-container">
  <button type="button" class="btn btn-box-tool" data-widget="collapse">
    <i class="fa fa-minus"></i>
  </button>
</div>  -->
<!-- Update 1/04/22 -->
<div class="grid table-demo">
  <div class="col-12">
    <div class="card mt-2">
      <h5>{{ title }}</h5>
      <div class="grid">
        <div class="col">
          <button
            pButton
            type="button"
            label="{{ 'Hoy' | translate }}"
            class="p-button-sm mr-1"
            [class]="
              buttonSelected === 'DAY'
                ? 'p-button-info'
                : 'p-button-secondary p-button-outlined'
            "
            (click)="getDataByLocation('DAY')"
          ></button>
          <button
            pButton
            type="button"
            label="{{ 'Semana' | translate }}"
            class="p-button-sm mr-1"
            [class]="
              buttonSelected === 'WEEK'
                ? 'p-button-info'
                : 'p-button-secondary p-button-outlined'
            "
            (click)="getDataByLocation('WEEK')"
          ></button>
          <button
            pButton
            type="button"
            label="{{ 'Mes' | translate }}"
            class="p-button-sm mr-1"
            [class]="
              buttonSelected === 'MONTH'
                ? 'p-button-info'
                : 'p-button-secondary p-button-outlined'
            "
            (click)="getDataByLocation('MONTH')"
          ></button>
        </div>
      </div>
      <div id="p-chart">
        <!-- <dx-chart
          id="chart"
          title="{{ 'Totales por Ubicación' | translate }}"
          [dataSource]="totalsSummary"
          [redrawOnResize]="true"
        >
          <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
          <dxi-series
            *ngFor="let serie of series"
            valueField="total"
            name="{{ serie.labelField | translate }}"
          ></dxi-series>
          <dxi-value-axis [position]="axisX.position">
            <dxo-title text="{{ axisX.label | translate }}"></dxo-title>
          </dxi-value-axis>
          <dxo-common-series-settings
            argumentField="current_location_name"
            type="stackedBar"
          >
          </dxo-common-series-settings>
          <dxo-legend
            verticalAlignment="bottom"
            horizontalAlignment="center"
            itemTextPosition="top"
          >
          </dxo-legend>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-tooltip
            [enabled]="true"
            location="edge"
            [customizeTooltip]="customizeTooltip"
          >
          </dxo-tooltip>
        </dx-chart> -->
      </div>
    </div>
  </div>
</div>